module.exports = __webpack_public_path__ + "static/media/galleryGT (13).62c3e78b.jpg";